import { AttorneyStage } from "../../../../../api/src/types";
import Calender from "../../icons/Calender";
import Home from "../../icons/Home";
import User from "../../icons/User";
import ThumbsUp from "../../icons/ThumbsUp";
import CreditCard from "../../icons/CreditCard";
import Questionmark from "../../icons/Questionmark";
import UserCircle from "../../icons/UserCircle";
interface AttorneyNavItem {
  icon: React.ReactNode;
  label: string;
  path: string;
  stage: AttorneyStage[];
}

export const attorneyNavItems: AttorneyNavItem[] = [
  {
    icon: <Home />,
    label: "Dashboard",
    path: "/",
    stage: [AttorneyStage.APPROVED],
  },
  {
    icon: <User />,
    label: "Clients",
    path: "/attorney/clients",
    stage: [AttorneyStage.APPROVED],
  },
  {
    icon: <Calender />,
    label: "Appointments",
    path: "/attorney/appointments",
    stage: [AttorneyStage.APPROVED],
  },
  {
    icon: <ThumbsUp />,
    label: "Reviews",
    path: "/attorney/reviews",
    stage: [AttorneyStage.APPROVED],
  },
  {
    icon: <CreditCard />,
    label: "Payouts",
    path: "/attorney/payouts",
    stage: [AttorneyStage.APPROVED],
  },
];

export const bottomAttorneyNavItems: AttorneyNavItem[] = [
  {
    icon: <Questionmark />,
    label: "Help",
    path: "/attorney/help",
    stage: [
      AttorneyStage.FORM_MISSING,
      AttorneyStage.UNDER_REVIEW,
      AttorneyStage.APPROVED,
      AttorneyStage.DECLINED,
      AttorneyStage.DEACTIVATED,
    ],
  },
  {
    icon: <UserCircle />,
    label: "Account",
    path: "/attorney/account",
    stage: [AttorneyStage.APPROVED],
  },
];
